import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs/';
import { map, catchError } from 'rxjs/operators';

import { CampaignsService, CampaignResponse, Campaign } from '@vestiaire/api-sdk-angular';
import { RoutingService } from '@app/core/services/routing.service';

@Injectable()
export class CatalogCampaignResolver implements Resolve<any> {
  constructor(private campaignsService: CampaignsService, private routingService: RoutingService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Campaign> {
    const id = this.routingService.getCampaignId(route.url[1].path);

    // Redirect '' to '/'
    if (route.url.length < 3) {
      const url = this.routingService.buildPath(route.url);
      this.routingService.redirectTo(url);
      return null;
    }

    return this.campaignsService.getCampaign(id).pipe(
      map((res: CampaignResponse) => res.data),
      catchError(err => {
        this.routingService.redirectError(err.status, state.url);
        return of(null);
      })
    );
  }
}
